import type { Environment } from '~/engine/data/Environment';
import type { PlaneView } from '~/engine/view/views/PlaneView';
import { RenderAdapter } from '../types';
import { usePlaneViewOf } from './usePlaneViewOf';

/**
 * The engine view behind a tile's renderer while it shows `host`, followed
 * across mounts; undefined for a view of another Environment, while there
 * is no host, before mount, and for a non-engine renderer (the mock
 * adapters). The gate of an overlay that belongs to one Environment's tiles.
 */
export function usePlaneViewHostedBy(
    renderer: RenderAdapter,
    host: Environment | undefined
): PlaneView | undefined {
    const view = usePlaneViewOf(renderer);
    return host && view?.environment === host ? view : undefined;
}
